import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'dayjs/locale/it';
import 'dayjs/locale/es';
import 'dayjs/locale/zh-cn';
import enTranslations from './locales/en.json';
import deTranslations from './locales/de.json';
import itTranslations from './locales/it.json';
import esTranslations from './locales/es.json';
import zhTranslations from './locales/zh.json';

const toDayjsLocale = (lng: string) => {
  if (lng.startsWith('de')) return 'de';
  if (lng.startsWith('it')) return 'it';
  if (lng.startsWith('es')) return 'es';
  if (lng.startsWith('zh')) return 'zh-cn';
  return 'en';
};

export const odooLangToI18n = (lang?: string | null): string => {
  const normalized = (lang ?? '').toLowerCase();
  if (normalized.startsWith('de')) return 'de';
  if (normalized.startsWith('it')) return 'it';
  if (normalized.startsWith('es')) return 'es';
  if (normalized.startsWith('zh')) return 'zh';
  return 'en';
};

const resources = {
  en: {
    translation: enTranslations,
  },
  de: {
    translation: deTranslations,
  },
  it: {
    translation: itTranslations,
  },
  es: {
    translation: esTranslations,
  },
  zh: {
    translation: zhTranslations,
  },
};

const initialLanguage = localStorage.getItem('language') || 'de';

i18n.use(initReactI18next).init({
  debug: true,
  resources,
  lng: initialLanguage,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

dayjs.locale(toDayjsLocale(initialLanguage));

export const changeLanguage = (lng: string) => {
  i18n.changeLanguage(lng);
  dayjs.locale(toDayjsLocale(lng));
  localStorage.setItem('language', lng);
};

export default i18n;
